const exemplarRawData = [
  [
    'ID',
    'Student_Feedback',
    'Exemplar_Statement',
    'Sub_Heading',
    'Category',
    'Stage_2',
    'Stage_3',
    'Stage_4',
    'Narratives',
    'Persuasive_Texts',
    'Advertisements',
    'Biographies_and_Autobiographies',
    'Descriptive_Writing',
    'Diary_and_Blog_Writing',
    'Discursive_Writing_(Discussion)',
    'Emails,_Texting_and_Messaging',
    'Information_Texts',
    'Instructions_and_Procedures',
    'Letter_Writing_and_Invitations',
    'Newspaper_Reports',
    'Poetry',
    'Recounts',
    'Reviews_and_Interviews',
    'Scriptwriting',
  ],
  [
    'dddcfc27-dc2b-4e0a-845d-3def373f50c5',
    '',
    'Cause and effect',
    'Arguments',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    '1853db6d-a28e-46b0-8693-867429e3329f',
    '',
    'Counterargument to show balance',
    'Arguments',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'dbc8b246-d608-4529-90e5-a5865138677f',
    '',
    'Important connections',
    'Arguments',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '87992ab2-f3d6-497e-aa47-7839c8ac6350',
    'Your story has a strong underlying message',
    'Strong underlying message',
    'Arguments',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
  ],
  [
    'a84b13ed-38dc-4030-9d4b-6c09519c8194',
    'Your arguments are clear and elaborated upon',
    'Well argued',
    'Arguments',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
  ],
  [
    'd5c24ae0-aad1-4ac9-8d0b-3477b3b0e486',
    'You have backfilled to explain more about the character/s setting /event',
    'Backfill provides further insight',
    'Backfill',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
  ],
  [
    'c045d017-475b-45db-8320-5a4a36bc9eff',
    'The characters are captivating to read about',
    'Captivating characters',
    'Characters',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
  ],
  [
    '03bf219a-aff9-49f5-ab69-630735e45dd6',
    'Well done on your use of a catalyst to add depth',
    'Catalyst to add depth',
    'Complications',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
  ],
  [
    '619ea0d1-a2be-40d9-bf48-d529eb1bc3d2',
    'Such an original problem to base your story around',
    'Original problem',
    'Complications',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
  ],
  [
    'ba16ae82-4652-4672-b34a-1f82a84eb438',
    'Such a relatable problem/complication to base your writing around',
    'Relatable problem',
    'Complications',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
  ],
  [
    '0ec7f3d5-e706-4607-a1c1-6a66c9b03c92',
    'Your have built growing tension into your writing',
    'Tension grows',
    'Complications',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
  ],
  [
    'f46e3519-8c67-4ea7-8657-317158d207c4',
    'Wow! An unexpected twist!',
    'Unexpected twist',
    'Complications',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
  ],
  [
    'fd3117fe-ce33-4e41-84ee-fac07ba3d77d',
    '',
    'Concludes with personal reflection',
    'Ending',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    'fbb87181-5399-4456-a8ef-fbecad0447c7',
    '',
    'Conclusion emphasises key points',
    'Ending',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '0',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
  ],
  [
    'd1ac0ba2-dd6d-4d6a-89a6-38a35c90e08b',
    'What a creative closing!',
    'Creative closing',
    'Ending',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
  ],
  [
    '7ca0f8af-f057-456b-bc4e-efa1da3405ea',
    '',
    'Concise, clear instructions',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    '0ca6295d-ad54-4f28-8e50-5cce897c600e',
    'You have carefully matched your writing to the task',
    'Content matches the task',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
  ],
  [
    '43f95979-c7be-47a8-ad13-a94aaa11d5ce',
    '',
    'Description of how something occurs',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'd0376df0-1af0-4838-8861-883d64a3175b',
    '',
    'Description of key features',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '',
  ],
  [
    'ed0ddeb4-11fd-4ddd-ba29-330591acb590',
    '',
    'Description of key parts',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    '888f8f1a-d2f3-4012-be00-777f4441deee',
    '',
    'Details and evidence',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
  ],
  [
    '4535d1b5-0007-430c-b51a-66bcdc4cc99b',
    '',
    'Example to expand a point',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    'f3e3ad15-d873-44b3-a8ea-a02abe0036e9',
    '',
    'Explains the perspectives of others',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
  ],
  [
    'a52d5c68-8082-4e12-923f-9b11c4ef848f',
    '',
    'Lists materials required',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    '063e6323-9fd1-435d-b7c3-503042d9d68a',
    '',
    'Opinion clearly stated',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    '742ae0cb-aab3-43da-9715-45c88bc04b54',
    'Such original ideas!',
    'Orginality of ideas',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
  ],
  [
    '4cd8e4e8-f359-40f4-b460-677cd4de625e',
    '',
    'Personal experiences',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '0d51b93e-62e1-44a6-8efa-24b69f5cf17d',
    '',
    'Purposeful use of Ethos, Pathos, Logos',
    'Key information',
    'Content and Ideas',
    '',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
  ],
  [
    '175cfb00-fdd0-443a-a6a5-52eca9c89a65',
    '',
    'Quotes to reinforce a point',
    'Key information',
    'Content and Ideas',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    '7aa9fe84-df1a-43f0-ad5d-3f9e274ba33d',
    '',
    'Specific dates and times',
    'Key information',
    'Content and Ideas',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
  ],
  [
    '4c7d2a01-91a9-4edb-8244-052ad6050a31',
    '',
    'Well explained',
    'Key information',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
  ],
  [
    '47a26436-4557-4ca9-a0ab-b100887019a2',
    'Your opening is attention-grabbing',
    'Attention-grabbing opening',
    'Opening',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '14c86ae5-4827-4f87-997c-4ecf76aa8457',
    '',
    'Clear aim, goal or desired outcome',
    'Opening',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
  ],
  [
    'bb5e4aaa-18a0-45a0-9339-b0fadadf327c',
    '',
    'Clear positioning in introduction',
    'Opening',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
  ],
  [
    '375be6d5-3c05-4f8f-8f60-5ddc132a41f0',
    'Your opening has hooked the reader in',
    'Effective opening hook',
    'Opening',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
  ],
  [
    '3fdcec72-3baa-440e-92f3-5946ac1f4a9a',
    'Great use of foreshadowing to hints at things to come',
    'Foreshadowing to hint of things to come',
    'Opening',
    'Content and Ideas',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
  ],
  [
    'c7985e9a-4a3f-447c-9b15-61d791b925f6',
    '',
    'Introduces self and purpose for writing',
    'Opening',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
  ],
  [
    '0437b9cf-d8b4-4a4b-9688-535314fbda1b',
    '',
    "Headline to catch reader's attention",
    'Title',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '',
  ],
  [
    'a4148ca3-0703-443f-a27f-9695348eeba7',
    'What an intriguing title!',
    'Intriguing title',
    'Title',
    'Content and Ideas',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
  ],
  [
    '63d6f9dd-86c9-4ee9-92ba-feca83e79f3b',
    '',
    'Dialogue',
    'Dialogue',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
  ],
  [
    'c1cc138d-e373-489b-b9ee-4e5eb4c22e8e',
    '',
    'Alliteration for effect',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
  ],
  [
    '556585ea-9ec5-4f22-a12d-19abdf555862',
    'The use of a hyperbole adds interest and enriches the language',
    'Hyperbole to enrich language',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
  ],
  [
    '1c9099b8-6cd0-41b3-9ee3-1f560b18a9e5',
    'The use of a metaphor adds interest and enriches the language',
    'Metaphor to enrich language',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
  ],
  [
    '43a2dd59-ba4b-45c1-ba18-6784d5818bb2',
    'The use of a personification adds interest and enriches the language language',
    'Personification to enrich language',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
  ],
  [
    '07c1474f-482a-4b46-ae94-148144312304',
    '',
    'Repetition for effect',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
  ],
  [
    '9ddc2f68-a19d-45d4-a1c2-8dbbc694d091',
    '',
    'Rhyme to add flow',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
  ],
  [
    '3510e33f-f15b-4179-a91a-318930312c83',
    'The use of a simile adds interest and enriches the language',
    'Simile to enrich language',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
  ],
  [
    'db9f34bb-de30-4898-a36b-dabf0aa5ac22',
    'The use of a symbolism deepens the meaning of your writing',
    'Symbolism to deepen meaning',
    'Literary Devices',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
  ],
  [
    'ae6a4732-fe18-473e-b679-7b944c85e268',
    'Great use of a question to evoke thinking',
    'Question to evoke thinking',
    'Questions',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
  ],
  [
    '025e9e4e-a499-4c8b-b0af-61c93ca93060',
    '',
    'Rhetorical question to engage reader',
    'Questions',
    'Language Choice',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '0',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    '5475a142-eb47-4f3c-bcc1-d9a4b3eb679c',
    'Your use of a complex sentence adds interest',
    'Complex sentence used for effect',
    'Sentences',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
  ],
  [
    '1030962d-7c3d-4afc-b3ba-d60e0565ac6d',
    'You have used concise sentence to make things clear',
    'Concise sentences provide clarity',
    'Sentences',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
  ],
  [
    '8ca589d0-2ae9-43ea-8973-5154e99cc304',
    'The use of varied sentence lengths adds impact',
    'Varied sentence length to add interest',
    'Sentences',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    'ebfc31ba-dd4b-4585-a6eb-c0cf3e70f1b8',
    'The different sentence starters makes it so interesting to read',
    'Varied sentence starters',
    'Sentences',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '976d74fb-deff-42d1-a0b2-dc62712d901e',
    '',
    'Action verbs',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
  ],
  [
    '3e6a5062-61ce-4f27-a198-ad653c1d1e92',
    'There are a number of cohesive devices that help your writing to flow',
    'Cohesive devices to link concepts',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
  ],
  [
    '7175ec84-7e97-4b54-8098-19caa12145f6',
    'Your use of emotive language draws in the reader and prompts feelings',
    'Emotive language prompts feelings',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    'd5118d6a-d6bc-4020-ad8e-09ce342ffbd1',
    '',
    'Objective language',
    'Vocabulary',
    'Language Choice',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
  ],
  [
    '14e7415e-3ce6-4a33-8eeb-ff96bdf646c8',
    '',
    'Passive verbs',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    'c1583f9a-a560-449d-85bd-ed7a54269fa5',
    '',
    'Persuasive language ',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    'faed2cb9-98e2-4bc7-9140-34a51be00b99',
    '',
    'Precise technical terms',
    'Vocabulary',
    'Language Choice',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '',
  ],
  [
    '87134d7a-e679-4e36-91c5-cd7cfa2f7c8c',
    'The setting description helps the reader to clearly visualise',
    'Prompts readers to visualise',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '61159c9d-b91d-4f45-a8aa-8cf5480b4015',
    'The rich use of adverbs and adjectives adds important detail',
    'Rich use of adverbs and adjectives',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    'f7e57d7e-fe66-4a9c-a487-f3ac5d9e5391',
    'Your sensory descriptions have built atmosphere',
    'Sensory descriptions applied to build atmosphere',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '1',
  ],
  [
    '27650741-3537-42d6-b104-28d6fa8ca29d',
    'Great choices regarding the specific nouns you have used.',
    'Specifc nouns and proper nouns',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    '88e3b29d-9156-47e1-8e0c-e5000c0d399a',
    '',
    'Topic-specific vocabulary',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    'cc3b9b19-3d88-4a55-b665-530a91b627b2',
    '',
    'Varied use of pronouns',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '',
  ],
  [
    '079fdbf2-576d-4028-95ee-374e4fa0d957',
    'These words have been clearly chosen to invite connotation',
    'Words that invite connotation',
    'Vocabulary',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
  ],
  [
    'e6995bb3-a8b3-4f6c-904e-3aa459b08f0c',
    '',
    "Clear writing 'voice'",
    'Voice',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '0d470b58-4540-4534-98b0-41c2a7ceb00e',
    'This exclamatory remark adds voice to your writing',
    "Exclamatory remark adds 'voice'",
    'Voice',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '9adb9408-934c-4611-a74d-5b5706d2e9df',
    '',
    'Catchphrase to be memorable',
    'Wordplay',
    'Language Choice',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '',
    '',
    '',
    '',
    '',
  ],
  [
    '830dca5e-0ee9-46cc-ab97-086d1a00aa1e',
    '',
    "Colloquial language to add 'voice'",
    'Wordplay',
    'Language Choice',
    '',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '2a3d1051-4dcb-4eba-ba8b-088453f11b38',
    'I am very impressed with your creative wordplay',
    'Creative wordplay',
    'Wordplay',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    '1b0131aa-99a2-40f6-80af-7a08f61cca2c',
    '',
    'Textspeak',
    'Wordplay',
    'Language Choice',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
  ],
  [
    'e30658a3-a278-4267-9ad0-2d099444b3bb',
    'Well done on your use of paragraphs to groups your ideas',
    'Ideas grouped into paragraphs for clarity',
    'Paragraphing',
    'Organisation and Structure',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    'c70133c0-b320-402a-8f52-411bf18f855e',
    '',
    'Key events recounted sequentially',
    'Sequencing of Ideas',
    'Organisation and Structure',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
  ],
  [
    '411ea7de-8e40-4e30-b9dd-5200626e5659',
    'You have sequenced ideas in a logical way',
    'Logically-sequenced ideas',
    'Sequencing of Ideas',
    'Organisation and Structure',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
  ],
  [
    '4a037b4d-4755-420c-ae28-1d0ef6822e37',
    'You have sequenced ideas based on time',
    'Time sequenced ideas',
    'Sequencing of Ideas',
    'Organisation and Structure',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
  ],
  [
    'dc315289-d015-465c-bf79-5097d4bf7b34',
    'This is an easy-to-read structure',
    'An easy-to-read structure',
    'Sequencing of Ideas',
    'Organisation and Structure',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    'b9e692dd-0b60-4d46-af03-1827a76a8edd',
    '',
    'Structure follows the task criteria',
    'Sequencing of Ideas',
    'Organisation and Structure',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    '276a180f-9ef2-4668-8230-6f3964c4e7f0',
    '',
    'Less common punctuation marks',
    'Punctuation marks',
    'Punctuation and Grammar',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
  ],
  [
    'f184e1af-ce46-4691-8956-3177c5468967',
    '',
    'Tense manipulated for effect',
    'Tense',
    'Punctuation and Grammar',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '',
  ],
  [
    'de231a7a-1b8d-4540-95d6-de4fda34163a',
    'This writing is well-pitched for your audience',
    'Well-pitched for the audience',
    'Impact on Reader',
    'Purpose and Audience',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
  [
    'c8ae7b9e-7fc3-4c74-a258-8d316a8c4b0c',
    '',
    'Conversational writing style',
    'Impact on Reader',
    'Purpose and Audience',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
  ],
  [
    '4e54f799-35b4-4829-9ae8-83e8d81e2d4c',
    '',
    'Formal writing style',
    'Impact on Reader',
    'Purpose and Audience',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '',
    '',
  ],
  [
    '44c3ce24-5af3-4639-874c-f00f55bd2cb7',
    'Your writing intrigues the reader',
    'Intrigues the reader',
    'Impact on Reader',
    'Purpose and Audience',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '',
    '',
    '',
  ],
  [
    'edc68cfc-9d26-4b78-a980-e60cab018745',
    'Your writing really makes the reader think!',
    'Makes the reader think',
    'Impact on Reader',
    'Purpose and Audience',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
  ],
  [
    'c64080ec-30e0-4b3c-b560-f163cad0e4b4',
    'The style of writing matches the task criteria',
    'The style of writing matches the task criteria',
    'Matching task criteria',
    'Purpose and Audience',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '',
  ],
  [
    'ac9b164e-6e0f-4603-ae6d-7daabe99ce03',
    '',
    'Appropriate Tone',
    'Impact on Reader',
    'Purpose and Audience',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
    '',
    '1',
    '',
    '1',
    '',
    '',
    '1',
    '1',
    '1',
    '1',
    '1',
    '1',
  ],
]
export default exemplarRawData
